import React from "react";
import { NavLink } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Blogarea from "../Blogarea";
import Ctaarea from "../Ctaarea";
import Teamarea from "../Teamarea";
import Key_Feature from "./Key_Feasures/Key_Feature";
import Aboute_Area from "./Key_Feasures/Aboute_Area";
import Counter_Area from "./Key_Feasures/Counter_Area";
import { BASE_URL } from "../Config/Config";
import SubLoading from "../ALL CSS/Loading";

function About() {
  // ------------ API CALL USING REACT QUERY ----------
  const fetchBannerImage = async () => {
    const res = await fetch(`${BASE_URL}/banner/?page=About-us`);
    const result = await res.json();
    return result.data[0]; // first banner object
  };

  const {
    data: bannerData,
    isLoading: bannerLoading,
    error: bannerError,
  } = useQuery({
    queryKey: ["aboutBanner"],
    queryFn: fetchBannerImage,
  });

  // ------------ UI RETURN ------------
  return (
    <>
      {/* Loader */}
      {bannerLoading ? (
        <SubLoading />
      ) : (
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: `url(${BASE_URL}${bannerData?.image})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
          data-overlay="title"
          data-opacity={8}
        >
          <div
            className="breadcumb-shape"
            data-bg-src="assets/img/bg/breadcumb_shape_1_1.png"
          ></div>

          <div
            className="shape-mockup breadcumb-shape2 jump d-lg-block d-none"
            data-right="30px"
            data-bottom="30px"
          >
            <img src="assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
          </div>

          <div
            className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none"
            data-left="50px"
            data-bottom="80px"
          >
            <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
          </div>

          <div className="container">
            <div className="breadcumb-content text-center">
              <h1 className="breadcumb-title">About Us</h1>
              <ul className="breadcumb-menu">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>About Us</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Service Area */}
      <Key_Feature />

      {/* About Area */}
      <Aboute_Area />

      <Counter_Area />

      {/* Team Area */}
      <Teamarea />

      {/* Blog Area */}
      <Blogarea />

      {/* CTA */}
      <Ctaarea />
    </>
  );
}

export default About;
